import Icon from "~/components/ui/Icon"

interface Props {
    children: string
    className?: string
}

export default function Title({ children, className: _class }: Props) {
    return (
        <div className={`flex items-center gap-2 mb-4 ${_class}`}>
            <Icon id='CoraçãoVitrine' size={20} className='text-black' />
            <h2 className='text-2xl font-black text-[26px] text-red-wine'>{children}</h2>
        </div>
    )
}
